import React, { ReactNode } from 'react';
import _ from 'lodash';
// import { useLocation } from 'react-router-dom'

import {
  Row,
  Col,
  Form,
} from 'react-bootstrap';
import styled from 'styled-components';
// import { up, down } from 'styled-breakpoints';

import { Checkbox } from "antd";

// Auth
// import { useAuthContext } from '../../../../auth/use-auth-context.js';
// import { useRouter } from '../../../../auth/auth-guard.js';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../utils/store.tsx';
import slice, { useFormikContext, fields } from './slice.tsx';

import Map from './Map.tsx';

// enums
import { convertLatLngToCoord, getAddressPlace, validateCoordinates, convertCoordToLatLng } from '../../../../utils/utils.tsx';
// import {  } from '../../../../utils/enums.tsx';

import GoogleSearchAddress from '../../../../components/googleMap/GoogleSearchAddress.jsx';

// components
// import MainContainer from '../../../../components/container/MainContainer.jsx';

// import { ReactComponent as XIcon } from "../../../../../v5/assets/icons/smallX.svg";

// ----------------------------------------------------------------------


const Tab = () => {
  // const location = useLocation();
  // const router = useRouter();
  
  const { values, errors, setValues, setFieldValue, validateForm, handleSubmit }: any = useFormikContext();

  // const { isLoading } = useTypedSelector((state: RootState) => state.jobFormDefaultLocationFormSlice);
  // const dispatch = useDispatch<AppDispatch>();


  const setFormElements = () => {
    return <Row className='g-8 mt-6'>
      <Col xs={12}>
        <Form.Group>
          <Form.Label>{fields.address.label}</Form.Label>
          <Form.Control
            as={GoogleSearchAddress}
            autoComplete='off'
            placeholder={fields.address.placeholder2}
            isInvalid={!!(errors && errors.address)}
            value={values.addressField}
            onPlaceSelected={async (place: any) => {
              let obj = getAddressPlace(place);

              if (obj?.address && obj?.lat && obj?.lng) {
                await setFieldValue('addressField', obj?.address);
                await setFieldValue('address', obj?.address);
                await setFieldValue('latitude', obj?.lat);
                await setFieldValue('longitude', obj?.lng);
                await setFieldValue('coordinates', obj?.coord);

                await validateForm().then((err: any) => {});
              }
            }}
            onChange={async (e) => {
              const addressField = e.target.value;

              await setFieldValue('addressField', addressField);

              if(addressField != '' && validateCoordinates(addressField)) {
                let coord = convertCoordToLatLng(addressField);
                if (coord) {
                  let coordinates = convertLatLngToCoord(coord.lat, coord.lng);
          
                  // Reset all fields and treat coordinates as a new address
                  await setFieldValue('addressField', addressField);
                  await setFieldValue('address', addressField);
                  await setFieldValue('latitude', coord.lat);
                  await setFieldValue('longitude', coord.lng);
                  await setFieldValue('coordinates', coordinates);

                  await validateForm().then((err: any) => {});
                }
              } else {
                await setFieldValue('address', '');
                await setFieldValue('latitude', '');
                await setFieldValue('longitude', '');
                await setFieldValue('coordinates', '');
              }
            }}
            onKeyDown={async (e: any) => {
              if ((e.charCode || e.keyCode) === 13) {
                e.preventDefault();
                e.stopPropagation();

                const addressField = e.target.value;
                if (validateCoordinates(addressField)) {
                  let coord = convertCoordToLatLng(addressField);
                  if (coord) {
                    let coordinates = convertLatLngToCoord(coord.lat, coord.lng);
            
                    // Reset all fields and treat coordinates as a new address
                    await setFieldValue('addressField', addressField);
                    await setFieldValue('address', addressField);
                    await setFieldValue('latitude', coord.lat);
                    await setFieldValue('longitude', coord.lng);
                    await setFieldValue('coordinates', coordinates);
  
                    await validateForm().then((err: any) => {});
                  }
                }
              }
            }}
            onBlur={async (e) => {
              const addressField = e.target.value;
              const address = values.address;
              const latitude = values.latitude;
              const longitude = values.longitude;
          
              // Rule 1: If addressField is empty, reset all fields
              if (!addressField) {
                await setFieldValue('addressField', '');
                await setFieldValue('address', '');
                await setFieldValue('latitude', '');
                await setFieldValue('longitude', '');
                await setFieldValue('coordinates', '');
                return;
              }
          
              // Rule 2: If addressField is a valid coordinate, treat it as a new address
              if (validateCoordinates(addressField)) {
                let coord = convertCoordToLatLng(addressField);
                if (coord) {
                  let coordinates = convertLatLngToCoord(coord.lat, coord.lng);
          
                  // Reset all fields and treat coordinates as a new address
                  await setFieldValue('addressField', addressField);
                  await setFieldValue('address', addressField);
                  await setFieldValue('latitude', coord.lat);
                  await setFieldValue('longitude', coord.lng);
                  await setFieldValue('coordinates', coordinates);

                  await validateForm().then((err: any) => {});
                }
                return;
              }
          
              // Rule 3: If addressField is manually changed, update address and call API
              if (addressField !== address) {
                let coordinates = convertLatLngToCoord(latitude, longitude);
                if (validateCoordinates(coordinates)) {
                  await setFieldValue('address', addressField); // Update address with the new value
                  await validateForm().then((err: any) => {});
                  return;
                }
              }
          
              // Rule 4: If address is a valid address with coordinates, keep the field as is
              if (address && latitude && longitude) {
                await validateForm().then((err: any) => {});
                return;
              }
          
              // If none of the above conditions are met, reset all fields
              await setFieldValue('addressField', '');
              await setFieldValue('address', '');
              await setFieldValue('latitude', '');
              await setFieldValue('longitude', '');
              await setFieldValue('coordinates', '');
            }}
          />
          <Form.Control.Feedback type="invalid">{errors && errors.address as ReactNode}</Form.Control.Feedback>
        </Form.Group>
      </Col>
      
      <Col xs={12}>
        <Checkbox
          checked={values.isSaveDefaultLocation}
          onChange={(e) => {
            setFieldValue('isSaveDefaultLocation', e.target.checked);
          }}
        >Save this location to Default Location</Checkbox>
      </Col>

      {values.isSaveDefaultLocation && <Col xs={12}>
        <Form.Group>
          <Form.Label>{fields.locationName.label}</Form.Label>
          <Form.Control
            type={'text'}
            autoComplete='off'
            placeholder={fields.locationName.placeholder2}
            disabled={false}
            value={values.locationName}
            onChange={(e: any) => {
              setFieldValue('locationName', e.target.value);
            }}
            isInvalid={!!(errors && errors.locationName)}
          />
          <Form.Control.Feedback type="invalid">{errors && errors.locationName as ReactNode}</Form.Control.Feedback>
        </Form.Group>
      </Col>}

      {(values?.coordinates != undefined && values?.coordinates != '') && <Col xs={12}>
        <Map 
          coordinates={values.coordinates}
          canMoveMarker={true}
          onDragEnd={(position: any) => {
            let coordinates = convertLatLngToCoord(position?.lat, position?.lng);

            setFieldValue('latitude', position?.lat);
            setFieldValue('longitude', position?.lng);
            setFieldValue('coordinates', coordinates);
            
            const addressField = values?.addressField;
            if (validateCoordinates(addressField)) {
              setFieldValue('addressField', coordinates);
              setFieldValue('address', coordinates);
            }
          }}
        />
      </Col>}
    </Row>
  }


  return <>
    {setFormElements()}
  </>
}

export default Tab;
